import { KeyValueMap } from ".";

export interface RFXBusinessInfoTemplate {
  templateType: string;
  templateOptions: TemplateOptionMap;
}

export interface TemplateOptionMap {
  categoryOptions: TemplateOption[];
  subCategoryOptions?: TemplateOption[];
  regionOptions: TemplateOption;
  currencyOptions: TemplateOption;
  organizationOptions: TemplateOption;
  departmentOptions: TemplateOption;
}

export interface TemplateOption {
  optionType: string;
  stringifiedOption: string;
}

export type AreaType = 'AMER' | 'APAC' | 'EMEA';

export type QuoteValidityTable = {
  [key in AreaType]: KeyValueMap<number>;
};

export const DEFAULT_QUOTE_VALIDITY = 6;

